import { action } from 'app/actions';

export const GET_LOGS = 'control-panel/GET_LOGS';
export const getLogs = payload => action(GET_LOGS, { payload });

export const RESET_LOGS = 'control-panel/RESET_LOGS';
export const resetLogs = () => action(RESET_LOGS);

export const GET_LOGS_READ = 'control-panel/GET_LOGS_READ';
export const getLogsRead = payload => action(GET_LOGS_READ, { payload });

export const RESET_CONTROL_PANEL = 'control-panel/RESET_CONTROL_PANEL';
export const resetControlPanel = () => action(RESET_CONTROL_PANEL);
